import gql from 'graphql-tag'

export const CASE_STUDY_BLOCK = gql`

query{
  caseStudies(sort: "Order:asc"){
    data{
      id
      attributes{
				Title
        caption
        Order
        slug
        FeaturedImage{
            data{
              attributes{
                url
                alternativeText
            	}
            }
        }
      }
    }
  }
}
`;
